function clickableMenu() {
    setTimeout(() => {
        // "Services" Menu
        const openIcon = document.querySelector("i.protego-menu");
        const closeIcon = document.querySelector("i.protego-close");
        const menu = document.querySelector("div.mobile--menu");
        if (openIcon && menu) {
            openIcon.addEventListener("click", (event) => {
                event.preventDefault();
                menu.classList.add("open");
            });
            closeIcon.addEventListener("click", (event) => {
                event.preventDefault();
                menu.classList.remove("open");
            });
        }
    }, 500);
};

export { clickableMenu };